import React from 'react'
import { compose } from 'recompose'
import withErrorBoundary from 'hoc/withErrorBoundary'
import withSessionRequired from 'hoc/withSessionRequired'
import { withWorkspaceContext } from 'context/WorkspaceContext'
import NotificationCenterApp from './NotificationCenterApp'
import Permission from '../Permission'
import { RouteComponentProps } from 'react-router'

interface NotificationsCenterFeatureGateProps extends RouteComponentProps<{}, {}> {
  workspace: {
    id: string
    billing: {
      isOnSelfServicePlan: boolean
    }
  }
  user: {
    isAdmin: boolean
  }
}

class NotificationCenterFeatureGate extends React.Component<NotificationsCenterFeatureGateProps> {
  render() {
    const { workspace, ...props } = this.props

    return (
      <Permission action="workspace:view" resourceid={workspace.id} resourcetype="workspace">
        {({ hasPermission }) => (hasPermission ? <NotificationCenterApp {...props} /> : null)}
      </Permission>
    )
  }
}

export default compose(
  withErrorBoundary(),
  withSessionRequired,
  withWorkspaceContext
)(NotificationCenterFeatureGate)
